export default "__VITE_ASSET__BMi4O55q__"